import { useSyncExternalStore } from 'react';

export type PhoebeChatDebugTimelineFocus = {
    readonly eventId: string | null;
    readonly requestId: number;
};

const listeners = new Set<() => void>();
const EMPTY_FOCUS: PhoebeChatDebugTimelineFocus = {
    eventId: null,
    requestId: 0,
};
let nextRequestId = 0;
let focus = EMPTY_FOCUS;

export function requestDebugTimelineFocus(eventId: string): void {
    nextRequestId += 1;
    focus = {
        eventId,
        requestId: nextRequestId,
    };
    for (const listener of listeners) {
        listener();
    }
}

export function consumeDebugTimelineFocus(requestId: number): void {
    if (focus.requestId !== requestId || focus.eventId === null) {
        return;
    }
    focus = {
        eventId: null,
        requestId,
    };
    for (const listener of listeners) {
        listener();
    }
}

function subscribe(listener: () => void): () => void {
    listeners.add(listener);
    return () => {
        listeners.delete(listener);
    };
}

function getFocus(): PhoebeChatDebugTimelineFocus {
    return focus;
}

export function usePhoebeChatDebugTimelineFocus(): PhoebeChatDebugTimelineFocus {
    return useSyncExternalStore(subscribe, getFocus, getFocus);
}
